@if (artist()) {
  <div class="bg-image">
    <app-image-generator
      [src]="artist()!.bannerImagePath!"
      [name]="artist()!.fullName + ' ' + artist()!.fullNameEnglish"
      imageType="landscape"
      [sizes]="artistBannerSizes"
    />
  </div>
  <div class="container secondary-section">
    <div class="person-container">
      <div class="person-information">
        <div class="avatar">
          <app-image-generator [src]="artist()!.imagePath" imageType="square" [name]="artist()?.fullName" />
        </div>
        <h1 class="title">{{ artist()?.fullName }}</h1>
        <h2 class="title-english">{{ artist()?.fullNameEnglish }}</h2>
        <p class="bio">
          @if (artist()?.biography && (artist()?.biography)!.length > 500) {
            <span>{{ artist()?.biography | slice: 0 : bioLength() }} ...</span>
            <button class="toggle-bio" mat-flat-button (click)="toggleBio()">
              نمایش {{ isSeeMoreActive() ? "کمتر" : "بیشتر" }}
            </button>
          } @else {
            <span>{{ artist()?.biography }}</span>
          }
        </p>
      </div>
    </div>
    @if (programs()) {
      <div class="person-programs">
        <h2>آثار هنرمند</h2>
        <div class="programs-list-container">
          @for (item of programs(); track item) {
            <app-sheyda-program-card ViewType="grid" class="list-item" [Item]="item" />
          }
        </div>
      </div>
    }
  </div>
}
